import React from 'react';
import {GestureHandlerRootView} from 'react-native-gesture-handler';
import {createStackNavigator} from '@react-navigation/stack';

import {AppRoute} from '../models/AppRoute';
import {RootStorybookParamList} from '../models/navigationTypes';
import StorybookScreen from '../screens/StorybookScreen';

import useCommonScreenOptions from './hooks/useCommonScreenOptions';

const Stack = createStackNavigator<RootStorybookParamList>();

/**
 * Root Storybook Stack Navigator
 *
 * Isolates Storybook's navigation from the main app navigation to prevent context conflicts.
 * Storybook has its own complete UI with internal navigation, so we hide the header.
 *
 * This creates a separate navigation tree accessible from the drawer menu
 * when STORYBOOK_ENABLED is true.
 */
const RootStorybookStackNavigator = () => {
  const commonScreenOptions = useCommonScreenOptions(true);

  return (
    <GestureHandlerRootView style={{flex: 1}} testID="gesture-handler-root-view">
      <Stack.Navigator detachInactiveScreens={true} screenOptions={commonScreenOptions}>
        <Stack.Screen
          name={AppRoute.STORYBOOK}
          component={StorybookScreen}
          options={{
            headerShown: false, // Storybook has its own UI
          }}
        />
      </Stack.Navigator>
    </GestureHandlerRootView>
  );
};

export default RootStorybookStackNavigator;
